import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	OnDestroy,
	AfterViewInit,
	ViewChild,
	ElementRef
} from "@angular/core";
import { ActivatedRoute, ROUTER_DIRECTIVES } from "@angular/router";
import { Observable } from "rxjs/Observable";
import {
	FORM_DIRECTIVES,
	FORM_PROVIDERS,
	REACTIVE_FORM_DIRECTIVES,
	FormGroup,
	Validators,
	FormControl
} from "@angular/forms";
import { AlertComponent, TYPEAHEAD_DIRECTIVES } from "ng2-bootstrap/ng2-bootstrap";
import { FILE_UPLOAD_DIRECTIVES, FileUploader } from "ng2-file-upload";
import { InfractionsService } from "../service/infractions.service";
import { CitiesService } from "../service/cities.service";
import { VehiclesService } from "../service/vehicles.service";
import { Infraction } from "../domain/infraction";
import { Address } from "../domain/address";
import { State } from "../domain/state";
import { City } from "../domain/city";
import { InfractionState } from "../domain/infractionState";
import { Regulator } from "../domain/regulator";
import { InfractionType } from "../domain/infractionType";
import {
	AMOUNT_VALIDATOR,
	DEFAULT_ERROR_MESSAGES,
	DATE_VALIDATOR,
	DATE_VALID_CHARACTERS,
	INTEGER_VALIDATOR,
	FILE_MAX_SIZE
} from "../validators/validators";
import { LoginService } from "../service/login.service";

@Component({
	selector: 'infraction-editor',
	template: require('./infraction.editor.component.html'),
	styles: [require('./infraction.editor.component.css')],
	directives: [
		FORM_DIRECTIVES,
		REACTIVE_FORM_DIRECTIVES,
		AlertComponent,
		TYPEAHEAD_DIRECTIVES,
		/*MyDatePicker,*/
		FILE_UPLOAD_DIRECTIVES,
		ROUTER_DIRECTIVES
	],
	providers: [FORM_PROVIDERS],
})
export class InfractionEditorComponent implements OnInit, OnDestroy, AfterViewInit {

	@Input() infraction: Infraction;
	@Output() close = new EventEmitter();

	private error: any;
	private sub: any;

	private date: Date;

	public errorMessages: any;

	public form: FormGroup;

	public infractionsType: InfractionType[];
	public infractionsState: InfractionState[];
	public states: State[];
	public stateSelected: State;
	public cities: City[];
	public regulators: Regulator[];

	public createMode: boolean;

	private infractionId: string;

	/*myDatePickerOptions:any;*/

	public errorMessage: string;
	public successMessage: string;

	public loading: boolean;

	regulatorName: string;

	public uploaderAct: FileUploader;
	public uploaderActPayReceipt: FileUploader;
	public uploaderDischarge: FileUploader;

	public hasActDropZoneOver: boolean;
	public hasActPayReceiptDropZoneOver: boolean;
	public hasDischargeDropZoneOver: boolean;

	public patentValid: boolean = false;

	public infractionTypeSelectedId: string;
	public infractionStateSelectedId: string;

	public infractionStateAddressSelectedId: string;
	public infractionCitySelectedId: string;

	public canEdit: boolean;

	public actNumberValid: boolean;

	private oldInfractionStateSelectedId: string;
	private oldActNumber: string;

	@ViewChild('inputAct') inputAct: ElementRef;
	@ViewChild('inputActPay') inputActPay: ElementRef;
	@ViewChild('inputDischarge') inputDischarge: ElementRef;

	public isUploading: boolean;

	constructor(private infractionsService: InfractionsService,
		private citiesService: CitiesService,
		private vehiclesService: VehiclesService,
		private route: ActivatedRoute,
		private loginService: LoginService) {
		this.init();
	}

	private init(): void {
		this.date = new Date();

		this.infraction = new Infraction();
		//this.infraction.withSendMail = true;

		this.errorMessages = DEFAULT_ERROR_MESSAGES;

		this.stateSelected = new State();
		this.regulators = [];

		this.loading = false;

		this.uploaderAct = new FileUploader({});
		this.uploaderActPayReceipt = new FileUploader({});
		this.uploaderDischarge = new FileUploader({});

		this.hasActDropZoneOver = false;
		this.hasActPayReceiptDropZoneOver = false;
		this.hasDischargeDropZoneOver = false;

		this.canEdit = false;

		this.infraction.withSendMail = true;

		this.isUploading = false;

		this.actNumberValid = false;

		this.oldActNumber = null;
		this.oldInfractionStateSelectedId = null;
	}

	private createFormGroup(): void {
		this.form = new FormGroup({
			actNumber: new FormControl(this.infraction.actNumber, [Validators.required]),
			type: new FormControl(this.infraction.infractionType, [Validators.required]),
			patent: new FormControl(this.infraction.vehicle.patent, [Validators.required]),
			infractionDate: new FormControl(this.infraction.infractionDate, [Validators.required, DATE_VALID_CHARACTERS, DATE_VALIDATOR]),
			infractionAmount: new FormControl(this.infraction.infractionAmount, [Validators.required, AMOUNT_VALIDATOR]),
			street: new FormControl(this.infraction.address.street),
			number: new FormControl(this.infraction.address.number),
			floor: new FormControl(this.infraction.address.floor),
			department: new FormControl(this.infraction.address.department),
			zipCode: new FormControl(this.infraction.address.zipCode, [INTEGER_VALIDATOR]),
			city: new FormControl(this.infraction.address.city.name, [Validators.required]),
			state: new FormControl(this.infraction.address.city.state.name, [Validators.required]),
			regulator: new FormControl(this.infraction.regulator),
			batch: new FormControl(this.infraction.batch, [DATE_VALID_CHARACTERS, DATE_VALIDATOR]),
			infractionState: new FormControl(this.infraction.state),
			amountPaid: new FormControl(this.infraction.amountPaid, [AMOUNT_VALIDATOR]),
			paymentDate: new FormControl(this.infraction.paymentDate, [DATE_VALID_CHARACTERS, DATE_VALIDATOR]),
			comments: new FormControl(this.infraction.comments),

			withSendMail: new FormControl(this.infraction.withSendMail)
		});
	}

	public ngOnInit() {
		let userLogged = this.loginService.getUserLogged();

		this.canEdit = userLogged.isActionAllowed('INFRACTIONS', 'EDIT', 'INFRACTIONS');

		/*this.myDatePickerOptions = {
		 dateFormat: 'dd/mm/yyyy',
		 /!*Descomentar para obtener un clone de un input de tipo 'date'*!/
		 /!*inline: false,
		 indicateInvalidDate: true*!/
		 };*/

		this.createFormGroup();

		this.sub = this.route.params.subscribe(params => {
			let infractionId = params['infractionId'];
			if (infractionId) {
				this.infractionId = infractionId;
				this.createMode = false;
				//this.infraction.withSendMail = false;
			} else {
				this.createMode = true;
				this.infractionId = null;
				//this.infraction.withSendMail = true;
			}
			this.getData();
		});
	}

	public ngAfterViewInit() {
	}

	private getData(): void {
		this.loading = true;

		let forkTasks: Observable<any>[] = [];
		forkTasks.push(this.infractionsService.getInfractionTypes());
		forkTasks.push(this.infractionsService.getInfractionStates());
		forkTasks.push(this.citiesService.getStates());
		if (this.infractionId) {
			forkTasks.push(this.infractionsService.getInfraction(this.infractionId));
		}
		Observable.forkJoin(forkTasks).subscribe(
			this.setData.bind(this),
			() => {
				this.bindError('Ocurrió un error al cargar los datos de infraccion.');
			});
	}

	private createInfraction(): void {
		this.infraction = new Infraction();
		this.stateSelected = new State();
		this.patentValid = false;
		this.infractionTypeSelectedId = null;
		this.infractionStateSelectedId = null;

		this.infractionStateAddressSelectedId = null;
		this.infractionCitySelectedId = null;

		if (this.infractionsType.length > 0) {
			this.infraction.infractionType = this.infractionsType[0];
			this.infractionTypeSelectedId = this.infraction.infractionType.id;
		}
		if (this.infractionsState.length > 0) {
			this.infraction.state = this.infractionsState[5];
			this.infractionStateSelectedId = this.infraction.state.id;
		}

		this.infractionsService.generateInfractionTempId()
			.subscribe(
				(response) => {
					this.infraction.tempId = response.value;
					this.updateUploadersUrl();
				},
				() => {
					this.bindError('Ocurrió un error al crear infraccion.');
				});

		//this.infraction.withSendMail = true;
	}

	private setData(data: any[]): void {
		this.loading = false;
		this.infractionsType = data[0];
		this.infractionsState = data[1];
		this.states = data[2];
		if (this.infractionId) {
			this.infraction = data[data.length - 1];
			this.infraction.tempId = this.infraction.id;
			this.patentValid = true;
			if (!this.infraction.address) {
				this.infraction.address = new Address(null);
			} else if (this.infraction.address.city && this.infraction.address.city.state) {
				this.infractionStateAddressSelectedId = this.infraction.address.city.state.id;
				this.infractionCitySelectedId = this.infraction.address.city.id;
				this.loadCities(this.infraction.address.city.state);
			}
			if (this.infraction.infractionType) {
				this.infractionTypeSelectedId = this.infraction.infractionType.id;
			}
			if (this.infraction.state) {
				this.infractionStateSelectedId = this.infraction.state.id;
			}

			this.oldInfractionStateSelectedId = this.infractionStateAddressSelectedId;
			this.oldActNumber = this.infraction.actNumber;

			//this.infraction.withSendMail = false;
			this.updateUploadersUrl();
		} else {
			this.createInfraction();
			//this.infraction.withSendMail = true;
		}
		if (!this.infraction.state) {
			this.infraction.state = this.infractionsState[0];
		}

		this.validateActNumber();
	}

	private updateUploadersUrl(): void {
		let fileOwnerId = this.infraction.tempId;
		this.uploaderAct = new FileUploader({
			url: 'infraction/' + fileOwnerId + '/upload/ACT',
			autoUpload: true,
			maxFileSize: FILE_MAX_SIZE,
		});
		this.uploaderActPayReceipt = new FileUploader({
			url: 'infraction/' + fileOwnerId + '/upload/ACT_PAY_RECEIPT',
			autoUpload: true,
			maxFileSize: FILE_MAX_SIZE,
		});
		this.uploaderDischarge = new FileUploader({
			url: 'infraction/' + fileOwnerId + '/upload/ACT_DISCHARGE',
			autoUpload: true,
			maxFileSize: FILE_MAX_SIZE,
		});
	}

	public ngOnDestroy() {
		this.sub.unsubscribe();
	}

	private clearMessages(): void {
		this.successMessage = null;
		this.errorMessage = null;
	}

	public isUploadingAFile() {
		this.isUploading = false;
		if (this.inputAct && this.inputAct.nativeElement && this.inputAct.nativeElement.value != '' && this.uploaderAct.queue && this.uploaderAct.queue.length == 0) {
			this.isUploading = true;
		}
		if (this.inputActPay && this.inputActPay.nativeElement && this.inputActPay.nativeElement.value != '' && this.uploaderActPayReceipt.queue && this.uploaderActPayReceipt.queue.length == 0) {
			this.isUploading = true;
		}
		if (this.inputDischarge && this.inputDischarge.nativeElement && this.inputDischarge.nativeElement.value != '' && this.uploaderDischarge.queue && this.uploaderDischarge.queue.length == 0) {
			this.isUploading = true;
		}
		if (this.uploaderAct.isUploading || this.uploaderActPayReceipt.isUploading || this.uploaderDischarge.isUploading) {
			this.isUploading = true;
		}
	}

	public save(): void {
		this.clearMessages();
		this.isUploadingAFile();
		if (!this.checkAllBeforeSave()) {
			this.loading = true;
			if (!this.infraction.withSendMail) {
				this.infraction.withSendMail = false;
			}
			if (!this.infraction.address.city || !this.infraction.address.city.id) {
				this.infraction.address.city.id = this.infractionCitySelectedId;
			}


			this.infractionsService.save(this.infraction).subscribe(
				(saved: Infraction) => {
					this.loading = false;
					this.infraction = saved;
					this.successMessage = 'La infracción se guardó con éxito';
					this.updateViewAfterSave();
				},
				(error) => {
					console.log(error);
					if (error.status == 501) {//NOT_IMPLEMENTED
						this.bindError('La infracción se guardó con éxito, pero falló al enviar mail.')
					} else if (error.status == 500) {
						if (error._body) {
							this.bindError(error._body);
						} else {
							this.bindError('Ocurrió un error al guardar la información.');
						}

					}
				});
		} else {
			this.bindError('Hay archivos pendientes. Recuerde que el tamaño máximo del archivo a subir es de 10Mb.');
		}
	}

	private checkAllBeforeSave() {
		return this.isUploading || !this.form.valid || this.loading || !this.patentValid || !this.actNumberValid || !this.infraction.infractionDate ||
			this.uploaderActPayReceipt.isUploading || this.uploaderAct.isUploading || this.uploaderDischarge.isUploading ||
			!this.infractionStateAddressSelectedId || !this.infractionCitySelectedId;
	}

	private updateViewAfterSave(): void {
		this.uploaderAct.clearQueue();
		this.uploaderActPayReceipt.clearQueue();
		this.uploaderDischarge.clearQueue();
		if (this.createMode) {
			this.createInfraction();
		} else {
			this.infraction.tempId = this.infraction.id;
		}
	}

	public goBack(event: any): void {
		event.preventDefault();
		this.close.emit(this.infraction);
		window.history.back();
	}

	private loadCities(state: State): void {
		this.loading = true;
		this.citiesService.getCities(state.id).subscribe(
			(data: City[]) => {
				this.loading = false;
				this.cities = data;
				// Si no hay una seleccionada, o el array no incluye la seleccionada: selecciono la primera de la lista
				if (!this.infractionCitySelectedId || !data.some(city => city.id === this.infractionCitySelectedId)) {
					this.infractionCitySelectedId = data[0].id;
				}
			},
			() => {
				this.bindError('Ocurrió un error al cargar las ciudades.');
			});
	}

	private clearCity(state: State): void {
		this.infraction.address.city = new City(null);
		this.infraction.address.city.state = state;
	}

	public onRegulatorSelected(regulator: any): void {
		this.infraction.regulator = regulator.item;
	}

	public fileOverAct(e: any): void {
		this.hasActDropZoneOver = e;
	}

	public fileOverActPayReceipt(e: any): void {
		this.hasActPayReceiptDropZoneOver = e;
	}

	public fileDischargeDischarge(e: any): void {
		this.hasDischargeDropZoneOver = e;
	}

	public removeAct(): void {
		this.infraction.act = null;
	}

	public removeActPayReceipt(): void {
		this.infraction.actPayReceipt = null;
	}

	public removeDischarge(): void {
		this.infraction.discharge = null;
	}

	public removeActFromQuee(item: any): void {
		this.infractionsService.deleteTempInfractionDocument(this.infraction.tempId, 'ACT').subscribe(
			(result) => item.remove(),
			() => {
				this.bindError('Ocurrió un error al eliminar acta de infraccion.');
			});
	}

	public removeActPayReceiptFromQuee(item: any): void {
		this.infractionsService.deleteTempInfractionDocument(this.infraction.tempId, 'ACT_PAY_RECEIPT').subscribe(
			(result) => item.remove(),
			() => {
				this.bindError('Ocurrió un error al eliminar comprobante de pago de infraccion.');
			});
	}

	public removeDischargeFromQuee(item: any): void {
		this.infractionsService.deleteTempInfractionDocument(this.infraction.tempId, 'ACT_DISCHARGE').subscribe(
			(result) => item.remove(),
			() => {
				this.bindError('Ocurrió un error al eliminar descargo de infraccion.');
			});
	}

	public validatePatent(): void {
		this.vehiclesService.getVehicleByPatent(this.infraction.vehicle.patent).subscribe(
			(vehicle) => {
				if (vehicle && vehicle.id) {
					this.infraction.vehicle = vehicle;
					this.patentValid = true;
				} else {
					this.infraction.vehicle.id = null;
					this.patentValid = false;
				}
			},
			() => {
				this.infraction.vehicle.id = null;
				this.patentValid = false;
				this.bindError('Ocurrió un error al validar patente de vehículo.');
			});
	}

	public infractionStateChange(newValue: any): void {
		let result = this.infractionsState.filter(function(obj: InfractionState) {
			return obj.id == newValue;
		});
		if (result.length > 0) {
			this.infraction.state = result[0];
		}
	}

	public onStateSelected(newValue: any): void {
		let result = this.states.filter(function(obj: State) {
			return obj.id == newValue;
		});
		if (result.length > 0) {
			this.loadCities(result[0]);
			this.clearCity(result[0]);
		}
		this.validateActNumber();
	}

	public onCitySelected(newValue: any): void {
		let result = this.cities.filter(function(obj: City) {
			return obj.id == newValue;
		});
		if (result.length > 0) {
			this.infraction.address.city = result[0];
		}
	}

	public validateActNumber(): void {
		if (this.checkOldValues()) {
			if (this.infraction.actNumber && this.infraction.address && this.infraction.address.city && this.infraction.address.city.state &&
				this.infraction.address.city.state.id) {
				this.infractionsService.getInfractionByActNumberAndState(this.infraction.actNumber, this.infraction.address.city.state.id).subscribe(
					(infraction) => {
						this.actNumberValid = !(infraction && infraction.id);
					},
					() => {
						this.actNumberValid = false;
						this.bindError('Ocurrió un error al validar la infracción.');
					});
			}
		} else {
			this.actNumberValid = true;
		}
	}

	private checkOldValues() {
		if (!this.oldInfractionStateSelectedId || !this.oldActNumber) {
			return true;
		}
		return !(this.infractionStateAddressSelectedId == this.oldInfractionStateSelectedId && this.infraction.actNumber == this.oldActNumber);
	}

	public infractionTypeChange(newValue: any): void {
		let result = this.infractionsType.filter(function(obj: InfractionType) {
			return obj.id == newValue;
		});
		if (result.length > 0) {
			this.infraction.infractionType = result[0];
		}
	}

	private bindError(messageError: string): void {
		this.loading = false;
		if (this.errorMessage == null) {
			this.errorMessage = messageError;
		} else {
			this.errorMessage = this.errorMessage.toString() + ' ' + messageError;
		}
	}

	/* Descomentar si se necesitan inputs (typeahead) y reemplazarlos por los actuales
	 onStateSelected(state:any) {
	 this.loadCities(state.item);
	 this.clearCity(state.item);
	 }

	 onCitySelected(city:any) {
	 this.bank.address.city = city.item;
	 }*/
}


/** WEBPACK FOOTER **
 ** ./src/app/infractions/infraction.editor.component.ts
 **/